// Nama pakej + jenis untuk satu rekod `orders` — dipapar dalam Rekod Jualan
// (Admin → Sales), fail Export CSV, dan Ringkasan Bisnes (Admin → Dashboard).
// SATU takrifan untuk semua tempat itu — kalau setiap tempat meneka sendiri,
// jadual dan papan pemuka akan bercanggah tentang order yang sama.
//
// Kunci `plan` ditulis oleh server (functions/index.js):
//   createBillplzBill   → 'premium' | 'fighter' | 'smart' | 'smart_upgrade' | 'flownity_addon'
//   createFlowUltraBill → 'flowultra_sharing' (+ productType 'flowultra')

// Bayaran Flow Ultra RM100 yang BERDIRI SENDIRI (halaman /flow).
// Sama seperti webhook billplzCallback: productType ATAU plan bermula 'flowultra'.
// ⚠️ Add-on Flow di dalam bil Premium (flowAddon:true, RM299) BUKAN padanan — itu kekal
//    jualan Premium "+Flow".
export function adalahFlowUltra(o) {
    if (!o) return false;
    return o.productType === 'flowultra' || String(o.plan || '').toLowerCase().startsWith('flowultra');
}

// Keputusan user 2026-09-13: NAMA PAKEJ SAHAJA. Add-on yang dibeli dalam bil yang
// sama (Flow Ultra +RM100, FLOWNITY +RM69) SENGAJA tidak disambung pada nama —
// add-on Flow Ultra sudah kelihatan dalam lajur Penghantaran.
// ⚠️ Pakej BAHARU yang ditambah di server tanpa dikemas kini di sini tidak hilang:
//    kunci mentahnya dipapar, supaya admin nampak ada sesuatu yang belum dinamakan.
export function namaPakejOrder(o) {
    if (!o) return '—';
    const plan = String(o.plan || '').toLowerCase();
    if (adalahFlowUltra(o)) return 'Flow Ultra';
    if (plan === 'premium') return 'Premium';
    if (plan === 'fighter') return 'Fighter';
    if (plan === 'smart') return 'SMART';
    if (plan === 'smart_upgrade') return 'Naik taraf SMART';
    if (plan === 'flownity_addon') return 'FLOWNITY add-on';
    if (plan) return plan;
    // Tanpa `plan`: diukur 2026-09-13 hanya 2 order (2 Jul 2026, belum dibayar) — kedua-duanya
    // lesen RM199, iaitu harga masuk Premium (satu-satunya pakej berharga itu ketika itu).
    if (o.type === 'license' && o.baseSen === 19900) return 'Premium';
    return '—';
}

// "Upgrade" = pelanggan SMART naik ke Premium (keputusan user 2026-10-09). Dua jalan:
//   1. `smart_upgrade` RM100 — lesen SMART masih aktif (dahulu berlabel "Add-on").
//   2. Pintu Premium pada harga MASUK RM199 — lesen SMART sudah tamat. Server menanda order
//      ini renew (`isRenewal:true`) + `hargaMasuk:true`; order sebelum medan itu wujud dikenal
//      daripada harga (renew sebenar = 9900, jadi 19900 pada order renew = harga masuk).
// ⚠️ KEMBAR: functions/index.js `bayarHargaMasuk` — harga 19900 = BILLPLZ_PLANS.premium.newSen.
//    Ubah harga masuk Premium di server = ubah di sini juga.
// Fighter SENGAJA tidak termasuk: "naik taraf ke Fighter" ada kotak sendiri dalam Ringkasan Bisnes.
export const HARGA_MASUK_PREMIUM_SEN = 19900;
export function adalahUpgrade(o) {
    if (!o || adalahFlowUltra(o)) return false;
    const plan = String(o.plan || '').toLowerCase();
    if (plan === 'smart_upgrade') return true;
    if (plan !== 'premium') return false;
    const renew = o.isRenewal === true || String(o.purchaseType || '').toLowerCase() === 'renewal';
    if (!renew) return false;
    return o.hargaMasuk === true || Number(o.baseSen) === HARGA_MASUK_PREMIUM_SEN;
}

// Lajur "Jenis" Rekod Jualan + Export CSV + sort lajur itu → 'Baru' | 'Sambung' | 'Upgrade' | 'Add-on'.
// Keputusan user 2026-09-15: SEMUA bayaran Flow Ultra RM100 = "Sambung", termasuk yang
// server tanda purchaseType 'new' (pembeli belum ada langganan Flow). Setiap pembeli Flow
// memang sudah pelanggan SESAAT; laporan admin menganggapnya renew Flow.
// ⛔ Paparan SAHAJA — medan order (purchaseType) TIDAK diubah. Pembeli Flow yang benar-benar
//    baharu (belum pernah ada langganan Flow) masih boleh dikenal daripada purchaseType asal itu.
export function jenisOrder(o) {
    if (!o) return 'Baru';
    if (adalahFlowUltra(o)) return 'Sambung';
    if (adalahUpgrade(o)) return 'Upgrade';
    if (o.purchaseType === 'addon') return 'Add-on';
    if (o.purchaseType === 'renewal') return 'Sambung';
    return 'Baru';
}
